// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2A-kU","col":"styles_col__3kWoh"};